<template>
    <div>
        <div id="info-container" :class="[$mq, { task: taskType, 'is-expanded': showExtraDetail, 'is-compact': isSmallScreen }]">
            <div class="header-main">
                <div class="detail-info-container" :class="[{ checklist: checklist }, { full: !hasMoreOptions }, { titleFullWidth: $route.name == 'AuditDetail' }]">
                    <div v-if="showBackButton" class="btn-content">
                        <div class="back-button" @click="goBack"></div>
                    </div>
                    <div class="detail-info" :class="[{ 'with-values': showExtraDetail }, { full: !hasMoreOptions }]" @click="infoOpened()">
                        <div class="detail-title" v-html="title"></div>

                        <div class="detail-complete" v-if="checklist">
                            <div class="hour" v-html="checkAvailability()"></div>
                        </div>
                        <div class="detail-created-at" v-if="showCompletedDate">
                            <span class="detail-text">
                                {{ $t('assets.timing.completed') }}
                            </span>
                            <span class="detail-text-date">
                                {{ formatDisplayDate(completed, { includeTime: true, emptyValue: '' }) }}
                            </span>
                        </div>
                        <div class="issue-info" v-if="issue">
                            <div class="detail-text">
                                <div class="created" v-if="issueCreatedBy && showExtraDetail">
                                    <div class="created-text">
                                        {{ $t('issue.created_at', { date: formatDate(issue.created_date) }) }}
                                    </div>
                                    <div class="user-container">
                                        <div class="employee-img" v-if="issueCreatedBy">
                                            <img v-if="issueCreatedBy.avatar && issueCreatedBy.avatar.includes('http')" :src="issueCreatedBy.avatar" alt="" />
                                            <img v-else-if="issueCreatedBy.avatar && issueCreatedBy.avatar.includes('file')" :src="issueCreatedBy.avatar" alt="" />
                                            <img v-else :src="css_image_url + 'avatar/' + issueCreatedBy.avatar" alt="avatar" />
                                        </div>
                                        <div class="employee-name" v-if="issueCreatedBy && Object.keys(issueCreatedBy).length > 0">
                                            {{ issueCreatedBy.name + ' ' + issueCreatedBy.surname }}
                                        </div>
                                    </div>
                                </div>
                                <div class="created" v-if="issueClosedBy && issue.complete_date && showExtraDetail">
                                    <div class="created-text">
                                        {{ $t('issue.closed_at', { date: formatDate(issue.complete_date) }) }}
                                    </div>
                                    <div class="user-container">
                                        <div class="employee-img" v-if="issueClosedBy">
                                            <img v-if="issueClosedBy.avatar && issueClosedBy.avatar.includes('http')" :src="issueClosedBy.avatar" alt="" />
                                            <img v-else-if="issueClosedBy.avatar && issueClosedBy.avatar.includes('file')" :src="issueClosedBy.avatar" alt="" />
                                            <img v-else :src="css_image_url + 'avatar/' + issueClosedBy.avatar" alt="avatar" />
                                        </div>
                                        <div class="employee-name" v-if="issueClosedBy && Object.keys(issueClosedBy).length > 0">
                                            {{ issueClosedBy.name + ' ' + issueClosedBy.surname }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="detail-created-at" v-if="showExtraDetail && !checklist && createdAt != '' && !issue">
                            <span class="detail-text">
                                {{ $t('assets.timing.created_at') }}
                            </span>
                            <span class="detail-text-date">
                                {{ formatDisplayDate(createdAt, { includeTime: true, emptyValue: '' }) }}
                            </span>
                        </div>
                        <div class="detail-user-info" v-if="showExtraDetail && userInfo && !issue">
                            <div class="employee-img" v-if="userInfo">
                                <img v-if="userInfo.avatar && userInfo.avatar.includes('http')" :src="userInfo.avatar" alt="" />
                                <img v-else-if="userInfo.avatar && userInfo.avatar.includes('file://')" :src="userInfo.avatar" alt="" />
                                <img v-else :src="css_image_url + 'avatar/' + userInfo.avatar" alt="avatar" />
                            </div>
                            <div class="employee-name" v-if="userInfo && Object.keys(employee).length > 0">
                                {{ employee.name + ' ' + employee.surname }}
                            </div>
                        </div>
                        <div class="audit-points" v-if="audit">
                            <div class="status" :class="audit.status">{{ $t('audit.status.' + audit.status) }}</div>

                            <div v-if="(audit.total != 0 && auditScore && auditScore.show_score == undefined) || auditScore.show_score == 1 || audit.complete_date">
                                <div v-if="audit.finalScore && audit.finalScore.name && audit.score > 0" class="final-score">
                                    <div v-if="audit.finalScore.color" class="final-score-color" :style="{ backgroundColor: audit.finalScore.color }"></div>
                                    <span class="text">{{ audit.finalScore.name }} ({{ formatDisplayPercent(audit.score, 3, true) }})</span>
                                </div>
                                <div v-else-if="audit.score != 0 || !audit.status == 'progress'" class="score-box">
                                    <div class="score" :class="scoreClasses(audit.score)">
                                        <span class="percent">{{ formatDisplayPercent(audit.score, 3, true) }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="resume" v-if="checklist">
                    <div v-if="showChecklistScore" class="score-box">
                        <div class="score" :class="checklistScoreClasses">
                            <span class="percent">{{ checklistScoreLabel }}</span>
                        </div>
                    </div>
                    <span v-else class="count" :class="{ done: checklist.completed == checklist.total }">
                        <span class="completed">{{ checklist.completed }}</span>
                        <span class="total">{{ '/' + checklist.total }}</span>
                    </span>
                </div>
                <div :class="hasOrderNew ? 'more-actions-container-more' : 'more-actions-container'" v-if="hasMoreOptions">
                    <div class="more-button" :class="{ active: showExtraDetail }" role="button" :aria-expanded="showExtraDetail ? 'true' : 'false'" @click="infoOpened()"></div>
                </div>
                <div :class="hasOrderNew ? 'more-actions-container-more' : 'more-actions-container'" v-else-if="hasOrder && userAppAccess">
                    <div class="more-button" :class="{ active: showExtraDetail }" role="button" @click="showOrderPopup()"></div>
                </div>
            </div>
            <div class="details" v-if="hasMoreOptions && showExtraDetail">
                <div class="more-buttons-content">
                    <div class="button-action reopen" v-if="hasReopen && completed" @click="reopenReport()">
                        <div class="reopen-btn"></div>
                        <span>{{ $t('menu_aux.action.reopen') }}</span>
                    </div>
                    <div class="button-action delete" @click="removeBtn()" v-if="!taskType && userAppAccess && (hasDelete || toolType !== 3)">
                        <div class="delete-btn">
                            <i class="i-andy-delete i-andy-m"></i>
                        </div>
                        <span>{{ $t('menu_aux.action.delete') }}</span>
                    </div>
                    <div class="button-action settings" @click="openSettings()">
                        <div class="settings-btn">
                            <i class="i-andy-menu-config i-andy-m"></i>
                        </div>
                        <span>{{ $t('menu_aux.action.settings') }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="checklist && hasChecklistProgressBar" class="detail-progress-bar">
           <div class="checklist-progress-bar-container">
               <div class="checklist-progress-bar">
                   <div class="checklist-progress-fill" :class="checklistProgressBarFillClasses" :style="{ width: checklistProgressBarPercentage }"></div>
               </div>
           </div>
       </div>
    </div>
</template>

<script>
import { formatPercent } from '@/utils/numberFormat'
import mixin from '@/core/mixin'
import { formatDisplayDateFromStore, formatDisplayTimeFromStore, formatDisplayDateTimeFromStore, formatDisplayDateOnlyFromStore } from '@/utils/dateFormatters'
import { getLocationMoment } from '@/utils/locationTime'

export default {
    name: 'AppccTopDetail',
    mixins: [mixin],
    props: {
        title: {
            type: String,
            default: ''
        },
        issue: {
            type: undefined,
            default: false
        },
        completed: {
            type: undefined,
            default: false
        },
        createdAt: {
            type: undefined,
            default: ''
        },
        userInfo: {
            type: undefined,
            default: false
        },
        hasMoreOptions: {
            type: Boolean,
            default: false
        },
        audit: {
            type: undefined,
            default: false
        },
        checklist: {
            type: undefined,
            default: false
        },
        showChecklistScore: {
            type: Boolean,
            default: false
        },
        auditScore: {
            type: undefined,
            default: false
        },
        notAvailable: {
            type: [Boolean, Object],
            default: false
        },
        taskType: {
            type: Boolean,
            default: false
        },
        showBackButton: {
            type: Boolean,
            default: true
        },
        hasOrder: {
            type: Boolean,
            default: false
        },
        hasReopen: {
            type: Boolean,
            required: true
        },
        hasDelete: {
            type: Boolean,
            required: true
        },
        hasOrderNew: {
            type: Boolean,
            default: false
        },
        toolType: Number,
        checklistProgressBar: {
            type: [Boolean, Object],
            default: false
        }
    },
    data() {
        return {
            // Mostrar info adicional
            showExtraDetail: false,
            isSmallScreen: false
        }
    },
    computed: {
        userAppAccess() {
            return this.$store.getters['loginUser/getHasAccessApp'] || (this.$store.getters['login/getKitchenModeFeatureFlag'] === 1 && (localStorage.kitchenMode == null || localStorage.kitchenMode === 'true'))
        },
        showCompletedDate() {
            if (!this.completed) {
                return false
            }

            if (this.isSmallScreen) {
                return this.showExtraDetail
            }

            return !this.checklist || this.showExtraDetail
        },
        user_id() {
            return this.$store.getters['loginUser/getLocalEmployee']
        },
        user() {
            var employee = this.$store.getters['employee/getEmployee'](this.user_id)
            if (employee) {
                return employee
            }
        },
        employee() {
            return this.$store.getters['employee/getEmployee'](this.userInfo.id)
        },
        issueCreatedBy() {
            if (!this.issue) {
                return false
            }
            if (this.issue.employee_ref && Object.keys(this.issue.employee_ref).length > 0) {
                return this.issue.employee_ref
            }

            if (!this.issue.complete_date && this.issue.employee && Object.keys(this.issue.employee).length > 0) {
                return this.issue.employee
            }
            return false
        },
        issueClosedBy() {
            if (!this.issue || !this.issue.complete_date) {
                return false
            }
            return this.issue.employee || false
        },
        checklistScoreValue() {
            if (!this.showChecklistScore || !this.checklist || this.checklist.score === undefined || this.checklist.score === null) {
                return null
            }

            let rawScore = this.checklist.score

            if (typeof rawScore === 'string') {
                rawScore = rawScore.replace('%', '').replace(',', '.').trim()
            }

            const value = Number(rawScore)

            if (Number.isNaN(value)) {
                return null
            }

            return value
        },
        checklistScoreLabel() {
            if (this.checklistScoreValue !== null) {
                const raw = this.checklist && this.checklist.score

                if (raw !== undefined && raw !== null && raw !== '') {
                    const normalized = String(raw).replace('%', '').trim()
                    return this.formatDisplayPercent(normalized.replace(',', '.'), 1)
                }

                return this.formatDisplayPercent(this.checklistScoreValue)
            }

            return '-'
        },
        checklistScoreClasses() {
            if (this.checklistScoreValue === null) {
                return {}
            }

            return this.scoreClasses(this.checklistScoreValue)
        },
        checklistProgressBarConfig() {
            if (!this.checklist || !this.checklistProgressBar) {
                return null
            }

            const baseScore = this.checklistScoreValue
            const normalizedScore = typeof baseScore === 'number' && !Number.isNaN(baseScore) ? Math.min(Math.max(baseScore, 0), 100) : 0

            const defaults = {
                itemsCompleted: normalizedScore,
                itemsTotal: 100,
                needJustification: false
            }

            if (this.checklistProgressBar && typeof this.checklistProgressBar === 'object' && !Array.isArray(this.checklistProgressBar)) {
                const overrides = this.checklistProgressBar || {}
                const config = {
                    ...defaults,
                    ...overrides
                }

                const total = Number(config.itemsTotal)
                config.itemsTotal = Number.isFinite(total) && total > 0 ? total : 100

                const completed = Number(config.itemsCompleted)
                config.itemsCompleted = Number.isFinite(completed) ? Math.min(Math.max(completed, 0), config.itemsTotal) : 0

                config.needJustification = Boolean(config.needJustification)

                return config
            }

            return defaults
        },
        hasChecklistProgressBar() {
            return !!this.checklistProgressBarConfig
        },
        checklistProgressBarPercentage() {
            const config = this.checklistProgressBarConfig

            if (!config || !config.itemsTotal) {
                return this.formatDisplayPercent(0)
            }

            const percentage = (config.itemsCompleted / config.itemsTotal) * 100
            const clamped = Math.max(0, Math.min(100, percentage))

            return this.formatDisplayPercent(clamped)
        },
        checklistProgressBarFillClasses() {
            const config = this.checklistProgressBarConfig

            if (!config) {
                return {}
            }

            const isDone = config.itemsCompleted >= config.itemsTotal && config.itemsTotal > 0
            const needsJustification = config.needJustification && !isDone

            return {
                done: isDone,
                justified: needsJustification,
                progress: !isDone && !needsJustification
            }
        }
    },
    methods: {
        formatDisplayPercent(value, level = 1, allowNegative = false) { return formatPercent(value, this.$i18n.locale, level, { allowNegative }) },
        scoreClasses(value) {
            return {
                success: value == 100,
                progress: value > 75 && value < 100,
                warning: value > 0 && value <= 75,
                error: value == 0
            }
        },
        showReopen() {
            this.$emit('hasReopen')
        },
        showDelete() {
            this.$emit('hasDelete')
        },
        reopenReport() {
            this.showExtraDetail = false
            this.$emit('reopenButton')
        },
        openSettings() {
            this.$emit('settingsButton')
        },
        checkAvailability() {
            if (!this.checklist || !this.checklist.limit || !this.checklist.limit.start || !this.checklist.limit.end) {
                return ''
            }

            const formatTimingTime = (value, { hourSuffix = false } = {}) => (
                formatDisplayTimeFromStore(value, { emptyValue: '', hourSuffix })
            )
            const formatTimingDateTime = (value, { hourSuffix = false } = {}) => (
                formatDisplayDateTimeFromStore(value, { emptyValue: '', hourSuffix })
            )
            const formatTimingEndTime = (value) => formatTimingTime(value)
            const formatTimingEndDateTime = (value) => formatTimingDateTime(value)
            const formatTimingDate = (value) => formatDisplayDateOnlyFromStore(value, { emptyValue: '' })
            const isSameCalendarDay = (left, right) => moment.utc(left).isSame(moment.utc(right), 'day')

            const now = getLocationMoment(this.$store.getters)
            const limitStart = moment.utc(this.checklist.limit.start)
            const limitEnd = moment.utc(this.checklist.limit.end)
            const businessDate = moment.utc(this.checklist.business_date)

            if (this.notAvailable) {
                return '<div class="ball-red"></div><span class="text">' +
                    this.$t('assets.timing.no_availbale_future') + ' ' +
                    formatTimingEndTime(this.checklist.limit.start) + ' ' +
                    this.$tc('assets.timing.to') + ' ' +
                    formatTimingEndDateTime(this.checklist.limit.end) + '</span>'
            }

            if (now.isAfter(limitStart) && now.isBefore(limitEnd)) {
                let finalPhrase = '<div class="ball-green"></div><span class="text">' +
                    this.$t('assets.timing.disponible') + ' '

                if (!isSameCalendarDay(limitStart, businessDate)) {
                    finalPhrase += formatTimingDateTime(limitStart) + ' ' + this.$tc('assets.timing.to') + ' '
                } else {
                    finalPhrase += formatTimingTime(limitStart) + ' ' + this.$tc('assets.timing.to') + ' '
                }

                if (!isSameCalendarDay(limitEnd, businessDate)) {
                    finalPhrase += formatTimingEndDateTime(limitEnd) + '</span>'
                } else {
                    finalPhrase += formatTimingEndTime(limitEnd) + '</span>'
                }

                return finalPhrase
            }

            if (now.isAfter(limitEnd)) {
                return '<div class="ball-red"></div><span class="text">' +
                    this.$t('assets.timing.no_availbale') + ' ' +
                    formatTimingDate(businessDate) +
                    '</span>'
            }

            if (now.isBefore(limitStart)) {
                if (isSameCalendarDay(limitStart, now)) {
                    if (!isSameCalendarDay(limitStart, limitEnd)) {
                        return '<div class="ball-red"></div><span class="text">' +
                            this.$t('assets.timing.no_availbale_future') + ' ' +
                            formatTimingEndTime(limitStart) + ' ' +
                            this.$tc('assets.timing.to') + ' ' +
                            formatTimingEndDateTime(limitEnd) + '</span>'
                    }

                    return '<div class="ball-red"></div><span class="text">' +
                        this.$t('assets.timing.no_availbale_future') + ' ' +
                        formatTimingEndTime(limitStart) + ' ' +
                        this.$tc('assets.timing.to') + ' ' +
                        formatTimingEndTime(limitEnd) + '</span>'
                }

                return '<div class="ball-red"></div><span class="text">' +
                    this.$t('assets.timing.no_availbale_future') + ' ' +
                    formatTimingDate(limitStart) +
                    '</span>'
            }

            return ''
        },
        getMaxHour(hourA, hourB) {
            return moment(hourA).valueOf() > moment(hourB).valueOf() ? hourA : hourB
        },
        getMinHour(hourA, hourB) {
            return moment(hourA).valueOf() < moment(hourB).valueOf() ? hourA : hourB
        },
        formatDate(date) {
            return this.formatDisplayDate(date, { includeTime: true, emptyValue: '' })
        },
        goBack() {
            this.$emit('backButton')
        },
        removeBtn() {
            this.$emit('deleteButton')
        },
        infoOpened() {
            if (this.isSmallScreen) {
                this.showExtraDetail = !this.showExtraDetail
                this.$emit('infoOpened')
                return
            }

            if (!this.checklist || this.taskType || this.completed) {
                this.showExtraDetail = !this.showExtraDetail
                this.$emit('infoOpened')
            }
        },
        showOrderPopup() {
            this.$emit('orderPopup')
        },
        syncSmallScreen(event) {
            this.isSmallScreen = event.matches
        }
    },
    created() {
        if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
            return
        }

        this.smallScreenQuery = window.matchMedia('(max-width: 600px)')
        this.isSmallScreen = this.smallScreenQuery.matches

        if (this.smallScreenQuery.addEventListener) {
            this.smallScreenQuery.addEventListener('change', this.syncSmallScreen)
        } else {
            this.smallScreenQuery.addListener(this.syncSmallScreen)
        }
    },
    beforeDestroy() {
        if (!this.smallScreenQuery) {
            return
        }

        if (this.smallScreenQuery.removeEventListener) {
            this.smallScreenQuery.removeEventListener('change', this.syncSmallScreen)
        } else {
            this.smallScreenQuery.removeListener(this.syncSmallScreen)
        }
    },
    filters: {
        moment: function (date, format) {
            return date ? moment(date).format(format) : ''
        }
    }
}
</script>

<style lang="scss">
#info-container {
    @include display-flex();
    @include justify-content(space-between);
    width: 100%;
    height: 100%;
    position: relative;

    .header-main {
        display: contents;
    }

    .detail-info-container {
        width: calc(100% - 45px);
        @include display-flex();
        gap: 8px;
        @extend .interaction;
        min-height: 40px;

        .detail-info {
            @include align-self(center);
            font-family: $text-bold;
            width: calc(100% - 45px);

            .detail-title {
                @extend .interaction;
                font-size: 18px;
                font-family: $text-sbold !important;
                line-height: 30px;
            }
            .detail-complete {
                @include display-flex();
                .hour {
                    @include display-flex();
                    @include align-items(center);

                    .ball-green {
                        @include border-radius(50%);
                        width: 12px;
                        height: 12px;
                        min-width: 12px;
                        min-height: 12px;
                        background-color: $done;
                        margin-right: 6px;
                    }
                    .ball-red {
                        @include border-radius(50%);
                        width: 12px;
                        height: 12px;
                        min-width: 12px;
                        min-height: 12px;
                        background-color: $error;
                        margin-right: 6px;
                    }
                    .text {
                        @include font-size(s);
                        font-family: $text;
                        color: $neutro-s80;
                    }
                }
                .date {
                    padding-left: 6px;
                    @include font-size(sm);
                    width: fit-content;
                    font-family: $text-light;
                    color: $main-dark;
                }
            }
            .detail-created-at {
                width: 100%;
                @include display-flex();

                .detail-text {
                    padding-right: 6px;
                    @include font-size(s);
                }

                .detail-text-date {
                    @include text-ellipsis();
                    @include font-size(s);
                    width: max-content;
                }
            }
            .issue-info {
                @include display-flex();
                @include align-items(center);
                width: 100%;
                .detail-text {
                    // @include text-ellipsis();
                    width: 100%;

                    .created {
                        @include display-flex();
                        @include align-items(flex-start);
                        @include flex-direction(column);
                        @include font-size(s);
                        font-family: $text;
                        color: $neutro-s60;
                        height: auto;

                        .created-text {
                            @include text-ellipsis();
                            width: 100%;
                        }

                        .user-container {
                            @include text-ellipsis();
                            @include display-flex();
                            width: 100%;

                            .employee-img {
                                @include display-flex();
                                @include align-items(center);
                                width: 20px;
                                height: 20px;
                                min-width: 20px;
                                min-height: 20px;
                            }
                            .employee-name {
                                @include text-ellipsis();
                                @include font-size(s);
                                padding-left: 6px;
                                font-family: $text;
                                color: $neutro-s60;
                            }
                        }
                    }
                }
            }
            .detail-text {
                @include font-size(xs);
                font-family: $text;
                color: $neutro-s60;
            }
            .detail-text-date {
                @include font-size(xs);
                font-family: $text-bold;
                color: $neutro-s60;
            }

            .detail-user-info {
                @include display-flex();
                @include align-items(center);
                width: 100%;
                height: 22px;

                .employee-img {
                    @include display-flex();
                    @include align-items(center);
                    width: 20px;
                    height: 30px;
                }
                .employee-name {
                    @include text-ellipsis();
                    @include font-size(s);
                    padding-left: 6px;
                    font-family: $text;
                    color: $neutro-s60;
                }
            }
            &.with-values {
                align-self: unset;
                @include display-flex();
                @include flex-direction(column);
                gap: 4px;
            }
        }
        &.checklist {
            width: calc(100% - 80px);
        }
        &.full {
            width: fit-content;
            overflow: hidden;

            .detail-info {
                width: calc(100% - 25px);

                &.full {
                    align-self: center;

                    .detail-title {
                        cursor: default;
                    }
                }
            }
            &.titleFullWidth {
                width: 100% !important;
            }
        }
    }

    .resume {
        @include display-flex();
        @include align-items(center);
        align-items: flex-start;
        //@include justify-content(center);
        width: auto;
        // height: 45px;
        // padding-right: 20px;

        .score-box {
            @include display-flex();
            @include align-items(center);
            @include justify-content(center);
            @include border-radius(4px);
            background-color: #fff;
            min-height: 30px;
            padding: 0 9px;

            .score {
                @include display-flex();
                @include align-items(center);
                height: 30px;
                @include styScore();

                .percent {
                    @include font-size(sm);
                    font-family: $text-bold;
                    color: $main-dark;
                    line-height: 1;
                }
            }
        }

        .count {
            @include border-radius(4px);
            @include font-size(ml);
            font-family: $text-bold;
            background-color: #fff;
            padding: 6px 9px;
            color: $main-dark;

            .completed {
                color: inherit;
                font-family: inherit;
            }
            .total {
                color: inherit;
                font-family: inherit;
            }
        }
    }

    .more-actions-container {
        height: auto;
        flex-shrink: 0;
        margin-left: 4px;
        .more-button {
            @extend .interaction;
            @include background($image: img('more_vert_aaaaaa.svg'), $size: 20px);
            @include border-radius(4px);
            @include align-self(center);
            background-color: $default-sec-color;
            width: 40px;
            height: 40px;
            &.active {
                background-image: img('more_horizontal_aaaaaa.svg') !important;
            }
        }
    }

    .more-actions-container-more {
        height: auto;
        flex-shrink: 0;
        margin-left: 4px;
        margin-top: 6px;
        .more-button {
            @extend .interaction;
            @include background($image: img('kebab_neutral_600.svg'), $size: 24px);
            @include border-radius(4px);
            @include align-self(center);
            background-color: $default-sec-color;
            width: 43px;
            height: 43px;
            &.active {
                background-image: img('more_horizontal_aaaaaa.svg') !important;
            }
        }
    }

    .details {
        height: auto;
        position: absolute;
        z-index: $z-menu-top;
        right: 0px;
        top: 49px;

        .more-buttons-content {
            @include display-flex();
            @include align-items(center);
            @include justify-content(center);
            @include flex-direction(column);
            gap: 4px;
            background-color: $color-white;
            padding: 4px;
            @include border-radius(4px);
            box-shadow: none;
            margin-bottom: 2px;

            .button-action {
                @include display-flex();
                @include align-items(center);
                @include justify-content(center);
                @include border-radius(4px);

                cursor: pointer;

                width: 100%;
                min-height: 40px;
                &.delete {
                    background-color: $error-dark;
                }
                &.settings,
                &.reopen {
                    background-color: $main-dark;
                }

                span {
                    @include font-size(s);
                    font-family: $text-bold;
                    color: $color-white;
                    padding: 6px;
                    flex: 1 1 auto;
                }

                .delete-btn,
                .settings-btn {
                    flex: 0 0 40px;
                    height: 40px;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    i {
                        color: $color-white;
                    }
                }

                .reopen-btn {
                    @extend .interaction;
                    @include border-radius(4px);
                    @include align-self(center);
                    @include background($image: img('lockOpened.svg'), $size: 20px);
                    width: 40px;
                    height: 40px;
                }
            }
        }
    }

    .audit-points {
        @include display-flex();
        @include align-items(center);
        width: 100%;
        max-height: 50px;
        padding-top: 8px;

        .final-score {
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: 6px;
            padding-left: 3px;
            justify-content: center;

            .color-and-name {
                display: flex;
                gap: 8px;
                align-items: center;
                width: 100%;
                max-width: 100%;

                .text {
                    width: 100%;
                    white-space: nowrap;
                    overflow-x: hidden !important;
                    text-overflow: ellipsis !important;
                }
            }

            .final-score-color {
                border-radius: 50%;
                min-width: 16px;
                width: 16px;
                height: 16px;
            }

            .text {
                width: 100%;
                max-width: 100%;
                font-family: $text-medium;
                font-size: 18px;
                padding-top: 3px;
                line-height: 1.1em;

                max-height: 80px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;

                @media screen and (max-width: 400px) {
                    font-size: 16px;
                }
            }
        }

        .top-title {
            @include font-size(xs);
            font-family: $text !important;
            color: $neutro-s60;
            text-align: left;
            padding-right: 6px;
        }
        .score-box {
            @include display-flex();
            @include flex-wrap(wrap);
            @include align-items();
            @include justify-content();
            @include border-radius(4px);
            width: fit-content;
            background-color: #fff;
            max-width: calc(100%);
            height: 30px;
            padding: 0px 6px;

            .score {
                @include display-flex();
                @include align-items();
                height: 30px;
                @include styScore();
                width: auto;
                text-align: right;

                .points,
                .total,
                .percent {
                    display: inline-block;
                }

                .points {
                    @include font-size(s);
                    font-family: $conden-bold;
                    color: $neutro-s90;
                }
                .total {
                    @include font-size(s);
                    font-family: $conden-bold;
                    color: $neutro-s90;
                }

                .percent {
                    @include font-size(sm);
                    @include display-flex();
                    @include align-items();
                    font-family: $text-bold;
                    color: $main-dark;
                    height: 30px;
                    padding-top: 3px;
                }
            }
        }
        .status {
            @include font-size(sm);
            display: inline-block;
            padding: 6px;
            border-radius: 4px;
            text-align: center;
            line-height: 1.2;
            margin-right: 6px;
            height: 30px;
            max-height: 30px;

            &.completed {
                background-color: #1d7672;
                color: white;
            }
            &.progress {
                background-color: #244390;
                color: white;
            }
            &.scheduled {
                background-color: $info;
                color: $main;
            }
        }
    }

    &.is-compact {
        @include display-flex();
        @include flex-direction(column);
        @include align-items(stretch);
        height: auto;
        gap: 8px;

        .header-main {
            @include display-flex();
            @include justify-content(space-between);
            @include align-items(flex-start);
            width: 100%;
            gap: 8px;
        }

        .detail-info-container {
            flex: 1 1 auto;
            min-width: 0;
            width: auto;

            &.checklist {
                width: auto;
            }
        }

        .more-actions-container,
        .more-actions-container-more {
            .more-button {
                background-color: $color-white;
            }
        }

        .details {
            position: relative;
            top: auto;
            right: auto;
            width: 100%;
            padding-top: 0;
            z-index: auto;

            .more-buttons-content {
                width: 100%;
                background-color: $color-white;
                box-shadow: none;
                padding: 4px;
                gap: 8px;
                @include align-items(stretch);
            }

            .button-action.delete {
                order: 1;
            }

            .button-action.settings {
                order: 2;
            }
        }
    }

    &.portrait {
        display: flex;
        gap: 8px;

        &.task {
            width: 100%;
        }

        .resume {
            width: min-content;
        }
        .detail-info {
            .issue-info {
                .created {
                    @include font-size(xs, $important: true);
                }
            }
            .detail-title {
                font-size: 18px;
                line-height: 1.1rem;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            .detail-created-at {
                .detail-text {
                    overflow: hidden;
                    white-space: nowrap;
                    @include font-size(xs, $important: true);
                    width: max-content;
                }

                .detail-text-date {
                    @include font-size(xs, $important: true);
                    width: auto;
                }
            }
            .employee-name {
                @include font-size(xs, $important: true);
            }
            @include portrait-tablet {
                .employee-name {
                    @include font-size(s, $important: true);
                }
                // .detail-title {
                //     @include font-size(m, $important: true);
                // }
                .detail-created-at {
                    .detail-text {
                        @include font-size(s, $important: true);
                    }

                    .detail-text-date {
                        @include font-size(s, $important: true);
                    }
                }
            }

            &.with-values {
                .detail-created-at {
                    .detail-text {
                        overflow: hidden;
                        white-space: nowrap;
                        @include font-size(xs, $important: true);
                    }

                    .detail-text-date {
                        @include font-size(xs, $important: true);
                    }
                }
                .employee-name {
                    @include font-size(xs, $important: true);
                }
                @include portrait-tablet {
                    .employee-name {
                        @include font-size(s, $important: true);
                    }
                    .detail-created-at {
                        .detail-text {
                            @include font-size(s, $important: true);
                        }

                        .detail-text-date {
                            @include font-size(s, $important: true);
                        }
                    }
                }
            }
        }
        .audit-points {
            .status {
                @include font-size(xs);
            }
        }
        .detail-info-container {
            &.full {
                width: calc(100% - 60px);

                .detail-info {
                    width: calc(100% - 40px);
                }

                .detail-complete {
                    padding-top: 4px;

                    .hour {
                        @include align-items(flex-start);
                        .ball-green,
                        .ball-red {
                            position: relative;
                            top: 4px;
                        }
                        .text {
                            @include font-size(xs, $important: true);
                            line-height: 20px;
                        }
                    }
                }
                @include portrait-tablet {
                    .detail-complete {
                        .hour {
                            .text {
                                @include font-size(xs, $important: true);
                                width: calc(100% - 2px);
                            }
                        }
                    }
                }
            }
        }
    }
}

.detail-progress-bar {
        width: 100%;
        margin-top: 8px;

        .checklist-progress-bar-container {
            max-width: 100%;
            height: 8px;
            @include display-flex();
            @include align-items(flex-end);
            @include justify-content(center);
            padding: 0 8px;
            position: relative;
            width: 100%;
            background-color: transparent;
            z-index: 1;

            .checklist-progress-bar {
                width: 100%;
                height: 4px;
                background-color: $color-neutral-300;
                @include border-radius(10px);
                overflow: hidden;

                .checklist-progress-fill {
                    height: 4px;
                    width: 0;
                    @include border-radius(10px);
                    transition: width 0.3s ease-in-out;

                    &.done {
                        background-color: #1ba844;
                    }
                    &.progress {
                        background-color: #1ba844;
                    }
                    &.justified {
                        background-color: $warning;
                    }
                }
            }
        }
    }
</style>
